import { render, staticRenderFns } from "./TourLoading.vue?vue&type=template&id=13b0a2f0&"
import script from "./TourLoading.vue?vue&type=script&lang=js&"
export * from "./TourLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports